import React, {useContext} from 'react';

export const AbsenceCodesContext = React.createContext(null);

export const useAbsenceCodesContext= () =>  useContext(AbsenceCodesContext) ;